import { Http } from '../../utils/http';
import { Api } from '../../utils/config';

const getVoteRule = async (id: string) => {
  const data = await Http.get(Api().host + `/votecenter/activity/${id}/info`)
  return data.data
}

export {
    getVoteRule
}


// WEBPACK FOOTER //
// ./src/components/activity_rule/api.ts